import { easepick } from '@easepick/core';
import { LockPlugin } from '@easepick/lock-plugin';

export const bookingWidget = () => {
	//Init the date picker for it!
	const bwPicker = new easepick.create({
	    element: "#js__booking-date",
	    css: [
	        "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.0/dist/index.css",
	        "https://cdn.jsdelivr.net/npm/@easepick/lock-plugin@1.2.0/dist/index.css",
	    ],
	    zIndex: 10,
	    format: "MMMM DD YYYY",
	    plugins: [LockPlugin],
	    LockPlugin: {
            minDate: Date.now(),
        },
	});

	//Handle submitting booking form
	const bookingSubmitButton = document.querySelector(".js__booking-submit");
	const otRefSelect = document.querySelector('#js__booking-location');
	const otDateInput = document.querySelector('#js__booking-date');
	const otTimeSelect = document.querySelector('#js__booking-time');

	if ( otRefSelect ) {
		otRefSelect.addEventListener('change', (event) => {
			// Clear existing error
			document.querySelector('.booking-widget__error').classList.add('hidden');
		});
	}

	if ( bookingSubmitButton ) {
		bookingSubmitButton.addEventListener('click', (event) => {
			event.preventDefault(); //Stop the link firing normally !

			// Clear existing error
			document.querySelector('.booking-widget__error').classList.add('hidden');

			// If the location is not selected, show the error
			if ( otRefSelect.value === '0' ) {
				document.querySelector('.booking-widget__error').classList.remove('hidden');
			} else {
				//Format and select the inputs
				const otRef =  otRefSelect.options[otRefSelect.selectedIndex].value;
				const otParty = 2;
				const otDateArr = formatOtDate(otDateInput.value);
				const otDateString = `${otDateArr.year}-${otDateArr.month}-${otDateArr.day}`;
				const otTimeRaw = otTimeSelect.options[otTimeSelect.selectedIndex].value;
				const otTime = otTimeRaw.split(':');
	
				//Put it all together!
				const otURL= `https://www.opentable.com/restaurant/profile/${otRef}/reserve?covers=${otParty}&dateTime=${otDateString}T${otTime[0]}%3a${otTime[1]}&restref=${otRef}&searchdatetime=${otDateString}T${otTime[0]}%3a${otTime[1]}&partysize=${otParty}&lang=en-US`;
	
				//Open it in a new tab
				window.open(otURL, '_blank');
			}

		});
	}
}

const formatOtDateNumber = (number) => {
	return number < 10 ? '0' + number : number;
}

const formatOtDate = (dateString) => {	
    // Split the date string into components
    const parts = dateString.split(' ');

    // Define months mapping
    const months = {
        "January": 1, "February": 2, "March": 3, "April": 4, "May": 5, "June": 6,
        "July": 7, "August": 8, "September": 9, "October": 10, "November": 11, "December": 12
    };

    // Extract day, month, and year
    const day = parts[1];
    const month = formatOtDateNumber(months[parts[0]]);
    const year = parts[2];

    // Return formatted object
    return { day, month, year };
}